/**
 * MobileMenu.jsx
 * Created by michaelbray on 5/7/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';

import * as Icons from '../../sharedComponents/icons/Icons';
import SearchInputContainer from '../../../containers/navigation/SearchInputContainer';
import DropdownMenuItems from '../../../components/navigation/account/DropdownMenuItems';

import * as loginActions from '../../../actions/navigation/loginActions';
import * as SecurityHelper from "../../../helpers/securityHelper";

const propTypes = {
    clickedMobileMenuButton: PropTypes.func,
    logout: PropTypes.func,
    showLoginModal: PropTypes.func,
    account: PropTypes.shape({
        account_id: PropTypes.string,
        cell_phone: PropTypes.string,
        email: PropTypes.string,
        emergency_contact: PropTypes.shape({
            first_name: PropTypes.string,
            last_name: PropTypes.string,
            phone: PropTypes.string
        }),
        favorites: PropTypes.array,
        first_name: PropTypes.string,
        home_address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            city: PropTypes.string,
            state: PropTypes.string,
            zip_code: PropTypes.string
        }),
        home_phone: PropTypes.string,
        is_commercial_account: PropTypes.bool,
        last_name: PropTypes.string,
        legacy_account: PropTypes.bool,
        passes: PropTypes.array,
        phone_alerts: PropTypes.bool,
        profile_picture_id: PropTypes.string,
        sms_alerts: PropTypes.bool,
        trip_preferences: PropTypes.array
    }),
    cart: PropTypes.shape({
        account_id: PropTypes.string,
        discount: PropTypes.string,
        err_message: PropTypes.string,
        expiration: PropTypes.string,
        hasError: PropTypes.bool,
        reservations: PropTypes.array,
        showSessionWarning: PropTypes.bool,
        showTimer: PropTypes.bool,
        subtotal: PropTypes.string,
        tax: PropTypes.string,
        total: PropTypes.string
    }),
    previewBannerHeight: PropTypes.number
};

const defaultProps = {
    cart: {},
    account: {},
    previewBannerHeight: 0
};

const searchInputQueryParam = 'headerTextQuery';

export class MobileMenu extends React.Component {
    constructor(props) {
        super(props);
        this.handleToggleLogIn = this.handleToggleLogIn.bind(this);

        this.state = {
            logIn: false,
            profilePictureURL: ''
        };

        this.showLoginModal = this.showLoginModal.bind(this);
    }

    componentDidMount() {
        if (this.props.account && this.props.account.profile_picture_id) {
            this.getProfilePicture(this.props.account.profile_picture_id)
                .then((response) => {
                    this.setState({
                        profilePictureURL: response.data.url
                    });
                });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.account && nextProps.account.profile_picture_id !== this.props.account.profile_picture_id) {
            if (nextProps.account.profile_picture_id) {
                this.getProfilePicture(nextProps.account.profile_picture_id)
                    .then((response) => {
                        this.setState({
                            profilePictureURL: response.data.url
                        });
                    });
            }
            else {
                this.setState({
                    profilePictureURL: ''
                });
            }
        }
    }

    getProfilePicture(id) {
        const url = `${process.env.API}/media/external/${id}`;
        return axios.get(url, { headers: { Authorization: SecurityHelper.getAuthHeader() } });
    }

    handleToggleLogIn() {
        this.setState((prevState) => {
            return {
                logIn: !prevState.logIn
            };
        });
    }

    showLoginModal() {
        this.props.showLoginModal();
    }

    renderSignInOrAccountPanel() {
        if (this.props.account !== null) {
            const firstName = this.props.account.first_name;

            let fullName = firstName;
            if (this.props.account.last_name.length > 0) {
                fullName = `${firstName} ${this.props.account.last_name[0]}.`;
            }

            let accountImage = <Icons.IconAccountCircle />;
            if (this.state.profilePictureURL) {
                accountImage = <img src={this.state.profilePictureURL} alt={fullName} />;
            }

            return (
                <div>
                    <button
                        className="nav-mobile-menu-row"
                        type="button"
                        title={fullName}
                        aria-label={fullName}>
                        {fullName}
                        <span className="nav-mobile-menu-row-icon">
                            {accountImage}
                        </span>
                    </button>
                    <DropdownMenuItems
                        commercialAccount={this.props.account.is_commercial_account}
                        signOut={this.props.logout} />
                </div>
            );
        }

        let logInActiveClass = "";
        if (this.state.logIn) {
            logInActiveClass = "nav-mobile-menu-log-in-active";
        }

        return (
            <button
                className={`nav-mobile-menu-row ${logInActiveClass}`}
                title="Sign Up / Log In"
                aria-label="Sign Up / Log In"
                type="button"
                onClick={() => this.showLoginModal()}>
                Sign Up / Log In
                <span className="nav-mobile-menu-row-icon">
                    <Icons.IconAccountCircle />
                </span>
            </button>
        );
    }

    render() {
        const signInOrAccountPanel = this.renderSignInOrAccountPanel();

        return (
            <div className="nav-mobile-menu" style={{ marginTop: `${this.props.previewBannerHeight}px` }}>
                <aside
                    role="complementary"
                    className="nav-mobile-menu-inner">
                    <div className="nav-mobile-menu-close-button-holder">
                        <button
                            className="nav-mobile-menu-close-button"
                            onClick={this.props.clickedMobileMenuButton}>
                            <Icons.IconClose />
                        </button>
                    </div>
                    <div className="nav-mobile-menu-body">
                        <SearchInputContainer
                            queryCriteriaPropertyName={searchInputQueryParam}
                            searchInputID="mobile-menu-search-input" />

                        <div className="nav-mobile-menu-account-panel">
                            { signInOrAccountPanel }
                        </div>

                        <button
                            className="nav-mobile-menu-row"
                            type="button"
                            title="Your Cart"
                            aria-label="Your Cart">
                            Your Cart
                            <span className="nav-mobile-menu-row-icon">
                                <Icons.IconCart />
                            </span>
                        </button>

                        <button
                            className="nav-mobile-menu-row"
                            type="button"
                            title="Help"
                            aria-label="Help">
                            Help
                            <span className="nav-mobile-menu-row-icon">
                                <Icons.IconHelpOutline />
                            </span>
                        </button>
                    </div>
                </aside>
            </div>
        );
    }
}

MobileMenu.propTypes = propTypes;
MobileMenu.defaultProps = defaultProps;

export default connect(
    (state) => ({
        modal: state.modal
    }),
    (dispatch) => bindActionCreators(loginActions, dispatch)
)(MobileMenu);
